
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/vcare",
      function () {
        return require("private-next-pages/case-study/vcare.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/vcare"])
      });
    }
  